import React, { useState, useEffect } from "react";
import Header from "../Components/SalesReport/Header";
import SalesReportOverview from "../Components/SalesReport/SalesReportOverview";
import { getSalesReport } from "../actions/SalesReportAction";
import NewEntryPage from "../Components/SalesReport/NewEntryPage";
import {
  getSalesReports,
  getSalesReportsWithQueries,
} from "../services/salesReportService";
import { getDistributorNames } from "../Common/functions";

const SalesReport = ({ userRole }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [addNewEntrySection, setAddNewEntrySection] = useState(false);

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0; // avoid division by zero
    return Math.ceil(totalItems / itemsPerPage);
  }

  const getApplicationReport1 = async () => {
    setData([]);
    setLoading(true);

    let distributorName;

    if (userRole === "super_admin") {
      distributorName = filters.distributorName;
    } else if (userRole === "manager") {
      distributorName =
        !filters.distributorName || filters.distributorName.trim() === ""
          ? getDistributorNames()
          : filters.distributorName;
    } else {
      distributorName = getDistributorNames();
    }

    try {
      const payload = {
        category: "sales tracking",
        tracking_status: "Sale",
        page_size: itemsPerPage,
        page_number: currentPage,
        start_date: filters.fromDate,
        end_date: filters.toDate,
        distributor_name: distributorName,
        doctorsname: filters.doctorName,
        group_title: filters.chooseTeam,
        product_group: filters.productGroup,
        product_code: filters.productName,
        search_term: searchTerm,
      };
      // Remove null, undefined, and empty string values
      const cleanedPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => {
          return value !== null && 
                value !== undefined && 
                value !== "" && 
                value !== " ".trim(); // Also removes whitespace-only strings
        })
      );

      const result = await getSalesReportsWithQueries(cleanedPayload);

      if (result?.data) {
        setData(result.data.items);
        setCurrentPage(result.data.current_page);
        setTotalCount(result.data.total_records);
        setTotalPages(getTotalPages(result.data.total_records, itemsPerPage));
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error in getApplicationReport1:", error);
    } finally {
      setLoading(false); // Ensure loading ends even on error
    }
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getApplicationReport1();
    }
  }, [searchTerm]);

  useEffect(() => {
    getApplicationReport1();
  }, [itemsPerPage, currentPage, filters]);
  return (
    <div>
      {addNewEntrySection ? (
        <>
          <NewEntryPage handleBack={() => setAddNewEntrySection(false)} />
        </>
      ) : (
        <>
          <Header
            NewEntryButtonVisibility={
              userRole === "super_admin" || userRole === "distributor_admin"
            }
            userRole={userRole}
            setAddNewEntrySection={setAddNewEntrySection}
          />
          <SalesReportOverview
            data={data}
            loading={loading}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            setCurrentPage={setCurrentPage}
            userRole={userRole}
            setSearchTerm={setSearchTerm}
            filters={filters}
            setFilters={setFilters}
            setItemsPerPage={setItemsPerPage}
            itemsPerPage={itemsPerPage}
          />
        </>
      )}
    </div>
  );
};

export default SalesReport;
